import { render, staticRenderFns } from "./ReviewStarsComponent.vue?vue&type=template&id=e3569502"
import script from "./ReviewStarsComponent.vue?vue&type=script&lang=js"
export * from "./ReviewStarsComponent.vue?vue&type=script&lang=js"
import style0 from "./ReviewStarsComponent.vue?vue&type=style&index=0&id=e3569502&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports